import SearchResultItem from "./SearchResultItem";

class SearchResult {
  constructor(
    public chelements_no: number,
    public e3dmodels_no: number,
    public e3dinstances_no: number,
    public annotations_no: number,
    public items: SearchResultItem[],
    public next_page: number,
    public page: number,
    public pages: number,
    public per_page: number,
    public prev_page: number,
    public total: number
  ) {}

  public static EmptyInstance(): SearchResult {
    return new SearchResult(0, 0, 0, 0, [], 0, 0, 0, 0, 0, 0);
  }
}

export default SearchResult;
